/*
 * @Author: cgh
 * @Date: 2022-08-01 10:50:50
 * @LastEditors: zxf
 * @LastEditTime: 2023-06-30 16:28:49
 * @Description: 评估项目管理
 */

const pgxmRoutes = {
  path: 'pgxm',
  name: 'pgxm',
  component: { template: '<router-view></router-view>' },
  children: [
    {
      path: 'list',
      name: 'pgxmManage',
      component: () => import(/* webpackChunkName: "pgxmManageList" */ '@/features/xfaqpg/pgxm/list.vue'),
      meta: {
        navtabTitle: '评估项目管理',
        isCache: true,
        ignoreDiff: [],
        isSecondary: false,
        menuElements: [
          { elementCode: 'pgxmManage_search', elementName: '查询' },
          { elementCode: 'pgxm_scbg', elementName: '生成报告' },
          { elementCode: 'pgxm_scbg_ls', elementName: '生成临时报告' },
          { elementCode: 'pgxm_cxpg', elementName: '重新评估' },
          { elementCode: 'pgxm_sqxg', elementName: '申请修改' },
          { elementCode: 'pgxm_qz', elementName: '签章' },
          { elementCode: 'pgxm_gz', elementName: '盖章' }
        ]
      }
    },
    {
      path: 'add',
      name: 'pgxmAdd',
      component: () => import(/* webpackChunkName: "pgxmAdd" */'@/features/xfaqpg/pgxm/add.vue'),
      meta: {
        navtabTitle: '添加评估项目',
        isCache: true,
        ignoreDiff: [],
        menuElements: []
      }
    },
    {
      path: 'edit/:id',
      name: 'pgxmEdit',
      // component: () => import(/* webpackChunkName: "pgxmEdit" */'@/features/xfaqpg/pgxm/addOrUpdateDialog.vue'),
      component: () => import(/* webpackChunkName: "pgxmEdit" */'@/features/xfaqpg/pgxm/details/edit.vue'),
      meta: {
        navtabTitle: '修改评估项目',
        isCache: true,
        ignoreDiff: [],
        menuElements: []
      }
    },
    {
      path: 'detail/:id',
      name: 'pgxmDetail',
      component: () => import(/* webpackChunkName: "pgxmDetail" */'@/features/xfaqpg/pgxm/details/view.vue'),
      meta: {
        navtabTitle: '查看评估项目',
        isCache: true,
        ignoreDiff: ['showType'],
        menuElements: []
      }
    }
  ]
};

export default pgxmRoutes;
